import { atom } from "recoil"
import { VrmLookupResponse } from "../repositories/vrm-lookup"

export const vehicleSearchResults = atom<VrmLookupResponse | undefined>({
    key: "vehicle.searchResults",
    default: undefined,
})
